import { Observable, of } from 'rxjs'
import { CanvasService } from '../canvas.service'
import {
  CanvasArgs,
  CanvasBaseCommand,
  CanvasCommandType,
  CanvasCommandVariant,
} from './canvas-command.model'

export interface NewCanvasArgs extends CanvasArgs {
  /** Client-side delegate that creates the canvas and selects it. */
  action?: () => void
}

export class NewCanvasCommand extends CanvasBaseCommand<NewCanvasArgs> {
  readonly id = 'new-canvas'
  readonly type: CanvasCommandType = 'invoker'
  override icon = 'auto_stories'
  override label = 'New'
  override tooltip = 'Create new canvas'
  override readonly variant: CanvasCommandVariant = 'button'

  constructor(canvasService: CanvasService) {
    super(canvasService)
  }

  protected doExecute(args?: NewCanvasArgs): Observable<boolean> {
    args?.action?.()
    return of(true)
  }
}
